import { render, staticRenderFns } from "./right.vue?vue&type=template&id=9de64766&"
import script from "./right.vue?vue&type=script&lang=ts&"
export * from "./right.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports